import * as React from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import * as classnames from 'classnames';

import {redirectToHome} from '../../history';
import {configEditorDispatchToPropsObject, globalDispatchToPropsObject} from '../../store';
import {Icon} from '../util';
import { NEW_URL_BANNER_FEATURE } from '../feature-flags';
import NewUrlBanner from './NewUrlBanner';

interface StateProps {
	username: string;
	authorized: boolean;
	loadedOnce: boolean;
	isEditing: boolean;
}

interface DispatchProps {
	logOut(): void;
	openSite(): void;
}

interface OwnProps {
	location: string;
	onClickHelp(): void;
}

type NavbarProps = StateProps & DispatchProps & OwnProps;

interface State {
	revealActionsDropdown: boolean;
}

function mapStateToProps({global, configEditor}: StudioState): StateProps {
	return {
		username: global.user.username,
		authorized: !!global.user.authorization,
		loadedOnce: !!configEditor.assets.loaded,
		isEditing: !!configEditor.assets.editing,
	};
}

function mapDispatchToProps(dispatch: Dispatch<StudioState>): DispatchProps {
	const {openSite} = configEditorDispatchToPropsObject;
	const {logOut} = globalDispatchToPropsObject;
	return {
		logOut: () => dispatch(logOut()),
		openSite: () => dispatch(openSite()),
	};
}

class Navbar extends React.Component<NavbarProps, State> {

	public state: State = {
		revealActionsDropdown: false,
	};

	constructor(props: NavbarProps, context: any) {
		super(props, context);
		this.handleClickActionsDropdown = this.handleClickActionsDropdown.bind(this);
		this.handleLeaveActionsDropdown = this.handleLeaveActionsDropdown.bind(this);
	}

	public render() {
		return <div className='navbar-header fixed'>
			{this.renderNewUrlBanner()}
			<nav className='navbar top-bar' role='navigation'>
				{this.renderTitleArea()}
				{this.renderSection()}
			</nav>
		</div>;
	}

	private renderTitleArea() {
		return <ul className='title-area'>
			<li className='name'>
				<h1>
					<a onClick={redirectToHome}>
						<div className='header-logo'>
							<div className='header-logo-text'>Configuration Tester</div>
							<div className='header-tool-text'>{this.getHeaderToolText()}</div>
						</div>
					</a>
				</h1>
			</li>
		</ul>;
	}

	private renderSection() {
		if (!this.props.authorized) {
			return null;
		}
		return <section className='top-bar-section'>
			<ul className='right'>
				{this.renderOpenSiteItem()}
				{this.renderHelpLink()}
				{this.renderGettingStartedGuideLink()}
				{this.renderDocumentationLink()}
				{this.renderDropdownSection(this.props.username)}
			</ul>
		</section>;
	}

	private renderDropdownSection(username: string) {
		return <li
			className={classnames('has-dropdown', this.getActionsMenuViewableClass())}
			onClick={this.handleClickActionsDropdown}
			onMouseLeave={this.handleLeaveActionsDropdown}
		>
			<a>{username}</a>
			<ul className='dropdown'>
				<li><a onClick={redirectToHome}>Home</a></li>
				<li><a onClick={this.props.logOut}>Logout</a></li>
			</ul>
		</li>;
	}

	private renderOpenSiteItem() {
		return this.props.loadedOnce && this.insideEditor() &&
			<li>
				<a onClick={this.props.openSite}>
					<Icon name='globe' /> Go to instance
				</a>
			</li>;
	}

	private renderGettingStartedGuideLink() {
		return <li>
			<a href={__V3_GETTING_STARTED_GUIDE_URL__} target='_blank'>
				<Icon name='forward' /> Getting Started
			</a>
		</li>;
	}

	private renderDocumentationLink() {
		return <li>
			<a href={__V3_DOCS_URL__} target='_blank'>
				<Icon name='book' /> Docs
			</a>
		</li>;
	}

	private renderHelpLink() {
		return this.props.isEditing && this.insideEditor() && <li>
			<a onClick={this.props.onClickHelp}>
				<Icon name='question-circle' /> Help
			</a>
		</li>;
	}

	private handleClickActionsDropdown() {
		this.setState({revealActionsDropdown: true});
	}

	private handleLeaveActionsDropdown() {
		this.setState({revealActionsDropdown: false});
	}

	private getActionsMenuViewableClass() {
		return this.state.revealActionsDropdown ? 'not-click' : '';
	}

	private insideEditor() {
		return this.props.location === '/editor';
	}

	private getHeaderToolText() {
		const {location} = this.props;
		if (location === '/editor') {
			return 'Editor';
		} else if (location === '/tester') {
			return 'Tester';
		} else {
			return null;
		}
	}

	private renderNewUrlBanner = () => {
		const onLogin = this.props.location.includes('login');

		// If disabling this banner, remove rem-calc(34) for scss variable $error-toast-top inside sass/_errorToast.scss
		if (!NEW_URL_BANNER_FEATURE || !onLogin) {
			return null;
		}

		return <NewUrlBanner/>;
	}

}

export default connect<StateProps, DispatchProps, OwnProps>
	(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-studio-index/Navbar.tsx